// Données de navigation pour les maisons astrologiques
export const maisonNavItems = [
  {
    title: 'Maison 1',
    image: '/images/maisons/maison1.png',
    url: '/blog/maisons/maison-1'
  },
  {
    title: 'Maison 2',
    image: '/images/maisons/maison2.png',
    url: '/blog/maisons/maison-2'
  },
  {
    title: 'Maison 3',
    image: '/images/maisons/maison3.png',
    url: '/blog/maisons/maison-3'
  },
  {
    title: 'Maison 4',
    image: '/images/maisons/maison4.png',
    url: '/blog/maisons/maison-4'
  },
  {
    title: 'Maison 5',
    image: '/images/maisons/maison5.png',
    url: '/blog/maisons/maison-5'
  },
  {
    title: 'Maison 6',
    image: '/images/maisons/maison6.png',
    url: '/blog/maisons/maison-6'
  },
  {
    title: 'Maison 7',
    image: '/images/maisons/maison7.png',
    url: '/blog/maisons/maison-7'
  },
  {
    title: 'Maison 8',
    image: '/images/maisons/maison8.png',
    url: '/blog/maisons/maison-8'
  },
  {
    title: 'Maison 9',
    image: '/images/maisons/maison9.png',
    url: '/blog/maisons/maison-9'
  },
  {
    title: 'Maison 10',
    image: '/images/maisons/maison10.png',
    url: '/blog/maisons/maison-10'
  },
  {
    title: 'Maison 11',
    image: '/images/maisons/maison11.png',
    url: '/blog/maisons/maison-11'
  },
  {
    title: 'Maison 12',
    image: '/images/maisons/maison12.png',
    url: '/blog/maisons/maison-12'
  },
  // {
  //   title: 'Maison 12',
  //   image: '/images/maisons/maison12.png',
  //   url: '/blog/maisons/maison-12'
  // }
  // {
  //   title: 'Maison 12',
  //   image: '/images/maisons/maison12.png',
  //   url: '/blog/maisons/maison-12'
  // }
]; 